import React from 'react'
import './AddVehicle/VehicleComponent.css'

export const VehicleOptions = ({
	title,
	options,
	register,
	name,
	required,
	onOptionChange,
}) => {
	return (
		<div className='vehicle-options-container'>
			<span className='vehicle-options-title'>{title}</span>
			<div className='options-row'>
				{options.map((option, index) => (
					<div key={index} className='option-item'>
						<input
							type='checkbox'
							{...register(name, {
								required: required
									? 'Veuillez cocher au moins une option.'
									: false,
							})}
							value={option}
							onChange={onOptionChange}
						/>
						<span>{option}</span>
					</div>
				))}
			</div>
		</div>
	)
}
